import React from "react";
import { Link as ScrollLink } from "react-scroll";

const FeatureCards = () => {
  return (
    <div className="feature-cards" id="FeatureCards">
      <ScrollLink to="FeatureCards" smooth={true} duration={500} offset={-70}>
        <div className="card">
          <h3>Rantai Pasok</h3>
          <p style={{ color: "#000" }}>
            Memastikan seluruh rantai pasoknya terdiri dari minyak kelapa sawit
            yang berasal dari sumber yang bertanggung jawab.
          </p>
        </div>
      </ScrollLink>
      <ScrollLink to="FeatureCards" smooth={true} duration={500} offset={-70}>
        <div className="card">
          <h3>Blockchain Technology</h3>
          <p style={{ color: "#000" }}>
            Mekanisme basis data lanjutan yang memungkinkan berbagi informasi
            secara transparan dalam jaringan bisnis.
          </p>
        </div>
      </ScrollLink>
      <ScrollLink to="FeatureCards" smooth={true} duration={500} offset={-70}>
        <div className="card">
          <h3>Model Konvensional</h3>
          <p style={{ color: "#000" }}>
            Seluruh stakeholder yang terkait tidak memiliki data satu sama lain
            dan tidak terhubung antar bagian.
          </p>
        </div>
      </ScrollLink>
      <ScrollLink to="FeatureCards" smooth={true} duration={500} offset={-70}>
        <div className="card">
          <h3>Model Digital</h3>
          <p style={{ color: "#000" }}>
            Seluruh stakeholder mempunyai data satu sama lain dalam proses
            keterelusuran hasil CPO.
          </p>
        </div>
      </ScrollLink>
    </div>
  );
};

export default FeatureCards;
